import { useMemo } from "react";

import { FIELDS, Organization } from "chq";

import { useProfile } from "app/context";
import { COMPANIES_TABLE, DEPARTMENTS_TABLE } from "app/utils/constants";

const defaultFieldLabels = {
  departments: {
    label: "Department",
    pluralLabel: "Departments",
    multipleFieldLabel: "Department(s)"
  },
  companies: {
    label: "Company",
    pluralLabel: "Companies",
    multipleFieldLabel: "Company(ies)"
  }
};

const getFieldLabel = (organization: Organization, table: "departments" | "companies", property: "label" | "pluralLabel" | "multipleFieldLabel", defaultValue: string) => (
  organization.organizationFields?.find(field => field.table === table)?.[property] || defaultValue
);

const getFieldLabels = (organization: Organization, table: "departments" | "companies") => ({
  singular: getFieldLabel(organization, table, "label", defaultFieldLabels[table].label),
  plural: getFieldLabel(organization, table, "pluralLabel", defaultFieldLabels[table].pluralLabel),
  multipleField: getFieldLabel(organization, table, "multipleFieldLabel", defaultFieldLabels[table].multipleFieldLabel)
});

const useFieldsLabels = (organizationContext?: Organization): FIELDS => {
  const { profile: { organization } } = useProfile();
  const org = organizationContext || organization as Organization;

  const labels = useMemo(() => ({
    companies: getFieldLabels(org, COMPANIES_TABLE),
    departments: getFieldLabels(org, DEPARTMENTS_TABLE)
  }), [org]);

  return labels;
};

export default useFieldsLabels;
